import { useAppContext } from "src/contexts/AppContext";
import getReferralCode, {
  GetReferralCodeResponse,
} from "src/features/referrals/services/getReferralCode";
import queryKeys from "src/lib/queryKeys";
import { useCurrentUser } from "src/SessionBoundary";
import useAppQuery, { AppQueryResult } from "./useAppQuery";

/** Load and indefinitely cache the current student's immutable referral code. */
export default function useReferralCode(): AppQueryResult<GetReferralCodeResponse> {
  const { clients } = useAppContext();
  const user = useCurrentUser();

  return useAppQuery<GetReferralCodeResponse>({
    queryKey: queryKeys.referralCode(user.uid),
    queryFn: () => getReferralCode(clients),
    staleTime: Infinity,
  });
}
